/***
**Module Name: add/edit client
 **File Name :  editclient.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains add/edit client data.
 ***/
 import React, { useState, useEffect, useContext } from "react";
 import Footer from "../../components/dashboard/footer";
 import Header from "../../components/dashboard/header";
 import Sidebar from "../../components/dashboard/sidebar";
 import tmdbApi from "../../api/tmdbApi";
 import Modal from 'react-bootstrap/Modal';
 import SweetAlert from 'react-bootstrap-sweetalert';
 import { useNavigate, Link } from "react-router-dom";
 import { useParams } from 'react-router-dom';
 import axios from "axios";
 import Loader from "../../components/loader";
 import moment from "moment";
 import SessionPopup from "../SessionPopup"
 import Select from 'react-select';
 import { contentContext } from "../../context/contentContext";
 import { Add } from "@mui/icons-material";
 import LocationSearch from "../LocationSearch";
 import { ToastContainer, toast } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';
 let { lambda, country, appname } = window.app;
 
 const EditClient = () => {
     const navigate = useNavigate();
     let { id } = useParams();
     const [nda, setNda] = useState(false);
     const [agreement, setAgreement] = useState(false);
     const [show, setShow] = useState(true);
     const [countries, setCountries] = useState('');
 
     const [error, setError] = useState("");
     const [activeMsg, setActiveMsg] = useState("");
     const [add, setAdd] = useState(false);
     const [success, setSuccess] = useState(false);
     const [errAccManage, setErrAccManage] = useState(false);
     const [companyInactivePopup, setCompanyInactivePopup] = useState(false);
     const [filesData, setFilesData] = useState([]);
     const [files, setFiles] = useState([]);
     const [termssuccess, setTermsSuccess] = useState(false);
     const [updated, setUpdated] = useState(false);
     const [message, setMessage] = useState(false);
     const [folowupcontent, setFollowupContent] = useState([]);
     const [account, setAccount] = useState([]);
 
     const [company, setCompany] = useState([]);
     const [companyValue, setCompanyValue] = useState({});
     const [editUser, setEditUser] = useState({ companyname: '', personalemail: '' });
     const [companyId, setCompanyId] = useState("");
     const [companyDeatilsList, setCompanyDetailsList] = useState({});
     const [toastMessage, setToastMessage] = useState("");
     const [toastType, setToastType] = useState("");// State for dynamic message
     const [phoneError, setPhoneError] = useState('');
     const [IdcError, setIdcError] = useState('');
 
     const [nameError, setNameError] = useState("");
     const [daysError, setDaysError] = useState("");
     const [percentError, setPercentError] = useState("");
     const [emailError, setEmailError] = useState("");
     const [typeError, setTypeError] = useState("");
 
     const [addressError, setAddressError] = useState("");
     const [planError, setPlanError] = useState("");
     const [entityError, setEntityError] = useState("");
     const [contentError, setContentError] = useState("");
     const [amError, setAmError] = useState("");
     const [companynameError, setCompanyNameError] = useState("");
     const [lastStatus, setLastStatus] = useState("");
     const [lastStatus2, setLastStatus2] = useState("");
     const [ShowStatusErrPopup, setShowStatusErrPopup] = useState(false);
 
 
     const [companyData, setCompanyData] = useState({});
     const [selectedCom, setSelectedCom] = useState({});
 
     const [individualdata, setIndividualData] = useState({});
     const [popup, setPopup] = useState(false);
     const [flag, setFlag] = useState(false);
     const [checkAM, setCheckAM] = useState("");
 
     const [createdon, setCreatedOn] = useState("");
     const [idc, setIdc] = useState("");
     const [defaultCountryCode, setDefaultCountryCode] = useState("");
 
     const [image, setImg] = useState('');
     const [approvedon, setApprovedOn] = useState("");
     const [termsacceptedon, setTermsAcceptedOn] = useState("");
     const [checkStatus, setCheckStatus] = useState(false);
     const [isLoading, setIsLoading] = useState(false);
     const [showSessionPopupup, setShowSessionPopupup] = useState(false);
     const [invalidContent, setInvalidContent] = useState(false);
     const [showRejectPopup, setShowRejectPopup] = useState(false);
     const [disableSaveBtn, setDisableSaveBtn] = useState(false);
     const [individualCompaniesList, setIndividualCompaniesList] = useState([]);
 
     const [followuptext, setFollowupText] = useState([]);
     const [lastCompanyName, setLastCompanyName] = useState("");
 
     const { route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, userData, setActiveMenuId, setActiveMenuObj, GetTimeActivity, mapsAPIkey } = useContext(contentContext);
     const [selectedPlace, setSelectedPlace] = useState('');
     const [addressData, setAddressData] = useState({});
     const [formData, setFormData] = useState({});
     //const [mapsAPIkey, setMapsAPIkey] = useState({});
     const [subscriptionsData, setSubscriptionsData] = useState([]);
     const [clientFlag, setClientFlag] = useState(false);
     let siteConfig = window?.site?.common;
     let appResourcesUrl = siteConfig?.imageCloudfront;
     const prevRoute = usePrevious(route)
     useEffect(() => {
         if (prevRoute !== undefined && prevRoute !== route) {
             setCurrentPage(1)
             setRowsPerPage(15)
         }
     }, [prevRoute]);
     // console.log('prevRoute--->',prevRoute)
     // console.log('currentRoute--->',route)
     // console.log("iddddddddddddddddddddddddd",id)
     useEffect(() => {
 
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    
    
    }, [window.site]);

 
     useEffect(() => {
         if (toastMessage && toastType && toast[toastType]) {
             toast[toastType](toastMessage, {
                 position: "bottom-center",
                 // autoClose: 3000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: true,
                 progress: undefined,
                 theme: "light",
             });
 
             // Clear the message after showing to prevent re-triggering
             setToastMessage && setToastMessage("");
         }
     }, [toastMessage, toastType]);
 
     useEffect(() => {
 
         if (!localStorage.getItem("token")) {
             navigate("/");
         }
         setRoute("client")
         setActiveMenuId(300001)
         setActiveMenuObj({
             "Client Management": true,
             "Contact Management": false,
             "Reports": false
         })
         GetCountries();
         if (id) {
             setAdd(false);
             getclient();
             setClientFlag(true)
             // GetCompany();
             // console.log("idddddddddddddddddddddddddd",id)
 
         }
         else {
             setAdd(true);
             // GetCompany();
         }
 
         // setAdd(true);
         // getAccount();
         // userActivity();
         getSbscriptionsApi()
     }, []);
     //   console.log("adddddddddddddddddddddddddddddddddddd",add)
     const userActivity = () => {
         let path = window.location.pathname.split("/");
         const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
         var presentTime = moment();
         let payload;
 
         payload = {
             "userid": localStorage.getItem("userId"),
             "pagename": pageName,
             "pageurl": window.location.href,
             "starttime": presentTime,
             "useragent": JSON.parse(localStorage.getItem("loc"))
 
         };
 
 
         const previousId = localStorage.getItem("previousid");
         const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");
 
 
         axios({
             method: 'POST',
             url: urlLink,
             data: payload
         })
             .then(function (response) {
                 if (response?.data?.statusCode === 200) {
                     localStorage.setItem("previousid", response?.data?.result)
                 }
             });
     }
 
     // useEffect(() => {
     //     if (id) {
     //         getFollowup();
     //     }
     // }, [updated]);
     // useEffect(() => {
 
     //     if (addressData && typeof addressData === 'object') {
     //         console.log("addressDatauseeffect", addressData)
     //         setEditUser((prevData) => ({
     //             ...prevData, // Keep the other fields intact
     //             ['businessaddress']: addressData?.fullAddress ? addressData?.fullAddress : addressData || "", // Update the changed field
     //         }));
     //     }
 
 
     // }, [addressData]);
 
     useEffect(() => {
         console.log("Debugging addressData:", addressData);
     
         if (addressData && typeof addressData === 'object') {
             console.log("Extracted fullAddress:", addressData.fullAddress);
     
             setEditUser((prevData) => ({
                 ...prevData,
                 businessaddress: addressData?.fullAddress || "", // Ensure it's a string
             }));
         }
     }, [addressData]);
     
 
 
     useEffect(() => {
         // console.log("useeffect flag", flag)
     }, [flag]);
 
     const getSbscriptionsApi = (e) => {
         axios({
             method: 'GET',
             url: lambda + '/getSubscriptions?appname=' + appname,
         })
             .then(function (response) {
                 if (response?.data?.result === "Invalid token or Expired") {
                     // setShowSessionPopupup(true)
                 } else {
                     setSubscriptionsData(response?.data?.result);
                     //setSelectedPlan("basic plan")
 
 
                 }
 
             }).catch((err) => {
                 console.log('error', err);
 
             });
     }
 
     const handleAddressChange = (addressData) => {
         console.log("fullAddress", addressData)
         setEditUser(prevState => ({
             ...prevState,
             businessaddress: addressData?.fullAddress || ''
         }));
         setAddressData(addressData)
     };
 
 
     const handleFileChange = (event) => {
         const selectedFile = event.target.files[0];
         // const selectedFilesSize = selectedFile.size; //for single file
         const selectedFiles = Array.from(event.target.files);  //for multiple files
         // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
         // console.log("selectedFile ", selectedFile)
         // console.log("selectedFiles ", selectedFiles)
         const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
         let fileSize = 1048612 * 5 // 5MB
         if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
             setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
             setToastType("warning")
             event.target.value = null;
             return;
         } else if (selectedFile.size < fileSize) {
             const previewUrl = URL.createObjectURL(selectedFile);
             console.log("prevvvvvvvvvvvvvvvvvvvvvv", previewUrl)
             setEditUser(prev => ({
                 ...prev,
                 logo: previewUrl
             }));
             setFilesData([selectedFile]); // Store file data
 
         } else {
             setToastMessage("File size should not exceed 5MB"); // Set the error message
             setToastType("warning")
             event.target.value = null;
 
         }
 
 
 
 
         // setFiles([...files, ...selectedFiles]); //for multiple files
 
 
 
 
     };
     const handleUploadSubmit = async () => {
 
         const ObjectID = require("bson-objectid");
         const uniqueId = new ObjectID().toString();
         // setLocationId(locationId)
 
 
 
 
 
 
         if (filesData && filesData?.length > 0) {
             setDisableSaveBtn(true)
             const uploadPromises = Array.from(filesData).map(async (file) => {
                 const timestamp = Date.now();
                 const fileExtension = file?.name?.split('.').pop();
                 const clientid = localStorage.getItem('userId');
                 const token = localStorage.getItem('token');
                 const ObjectID = require("bson-objectid");
 
                 const uniqueId = new ObjectID().toString();
                 let uploadFilePath;
                 let bucket;
 
                 // Check the file type
                 if (file.type.startsWith('image/')) {
                     // File is an image
                     let filenameReplace = file.name.replace(/ /g, "_")
                     uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                     bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                     const data = {
                         source_bucket: bucket, // Use the correct bucket based on file type
                         sourcepath: uploadFilePath
                     };
                     console.log("data", data)
                     const newFile = [{
                         filename: filenameReplace.split('.')[0],
                         filepath: uploadFilePath,
                         fileid: uniqueId,
                         filetype: file.type,
                         filesize: file.size,
                         fileformat: fileExtension
                     }]
                     const updatedFiles = [...files, ...newFile];
                     console.log("updatedFiles", updatedFiles)
                     setFiles(updatedFiles);
 
                     const uploadPromise = axios.post(
                         `${lambda}/uploadURL?appname=${appname}`,
                         data,
                         { headers: { 'Content-Type': 'application/json' } }
                     ).then(async uploadUrlResponse => {
                         if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                             const url = uploadUrlResponse.data.result;
 
                             return axios.put(url, file, {
                                 headers: {
                                     'Content-Type': file.type,
                                     'Cache-Control': 'no-cache'
                                 }
                             }).then(async uploadResponse => {
                                 if (uploadResponse.status === 200) {
                                     // setFiles([...files, ...newFile]); 
                                     // handleSubmit(updatedFiles);
                                     if (add) {
                                         SaveClient(updatedFiles)
                                     } else {
                                         handleUpdate(updatedFiles);
                                     }
 
                                 } else {
                                     throw new Error('Failed to upload file to S3');
                                 }
                             });
                         } else {
                             throw new Error('Failed to get upload URL');
                         }
                     });
 
 
                 }
 
 
             });
 
             try {
                 //const results = await Promise.all(uploadPromises);
                 await Promise.all(uploadPromises);
 
             } catch (error) {
                 console.error('Error during file upload:', error);
             }
         } else {
             // handleSubmit([], uniqueId);
             if (add) {
                 SaveClient([], uniqueId);
             } else {
 
                 handleUpdate([], uniqueId);
             }
 
 
         }
 
 
 
     }
     const handleRemove = () => {
         // setUploadImg("")
         //setFormData("")
         setFilesData([])
         setEditUser(prev => ({
             ...prev,
             logo: "" // Clear the logo array
         }));
     }
     const getclient = (e) => {
         GetTimeActivity()
         const token = localStorage.getItem("token")
         axios({
             method: 'GET',
             url: lambda + '/clientInfo?appname=' + appname + '&clientid=' + id
             // + "&token=" + token,
         })
             .then(function (response) {
                 if (response?.data?.result === "Invalid token or Expired") {
                     setShowSessionPopupup(true)
                 } else {
                     if (response?.data?.result.length > 0) {
                         const result = response?.data?.result?.[0];
                         setLastStatus(response?.data?.result?.[0]?.status)
                         setLastStatus2(response?.data?.result?.[0]?.status)
                         setLastCompanyName(response?.data?.result?.[0]?.companyname)
                         setEditUser(response?.data?.result?.[0]?.businessaddress)
                         setAddressData(response?.data?.result?.[0]?.businessaddress)
                         setSelectedPlace(response?.data?.result?.[0]?.businessaddress)
                         setEditUser(result)
                        
                        
                         if (response && response?.data && response?.data?.result?.[0] && response?.data?.result?.[0]?.created) {
                             var created_date = new Date(response?.data?.result?.[0]?.created);
                             var created_hour = created_date.getHours();
                             var created_min = created_date.getMinutes();
                             var created_sec = created_date.getSeconds();
                             setCreatedOn(created_hour + ':' + created_min + ':' + created_sec)
                         }
 
                         if (response && response?.data && response?.data?.result?.[0] && response?.data?.result?.[0]?.approvedOn) {
                             var created_date = new Date(response?.data?.result?.[0]?.approvedOn);
                             var created_hour = created_date.getHours();
                             var created_min = created_date.getMinutes();
                             var created_sec = created_date.getSeconds();
                             setApprovedOn(created_hour + ':' + created_min + ':' + created_sec)
                         }
                         if (response && response?.data && response?.data?.result?.[0] && response?.data?.result?.[0]?.termsAccptedOn) {
                             var created_date = new Date(response?.data?.result?.[0]?.termsAccptedOn);
                             var created_hour = created_date.getHours();
                             var created_min = created_date.getMinutes();
                             var created_sec = created_date.getSeconds();
                             setTermsAcceptedOn(created_hour + ':' + created_min + ':' + created_sec)
                         }
                         if (response?.data?.result?.[0]?.companydetails?.[0]?.accountmanager) {
                             setCheckAM(response?.data?.result?.[0]?.companydetails?.[0]?.accountmanager)
                             // console.log('check ammmmmmmm', response?.data?.result?.[0]?.companydetails?.[0]?.accountmanager)
                         }
                         //  editUser?.companydetails?.[0].accountmanager
                     } else {
                         setInvalidContent(true)
                     }
 
                 }
 
                 setDisableSaveBtn(false)
             });
     }
 
     // console.log('check am2222222',checkAM)
     // console.log('edit client', editUser)
     const onclickInvalid = () => {
         GetTimeActivity()
         setInvalidContent(false)
         navigate('/clients')
     }
 
     const GetCompany = () => {
         GetTimeActivity()
         const token = localStorage.getItem("token")
         axios({
             method: 'get',
             url: lambda + '/companylist?appname=' + appname + "&token=" + token + "&entity=INDIVIDUAL",
         })
             .then(function (response) {
                 if (response?.data?.result === "Invalid token or Expired") {
                     setShowSessionPopupup(true)
                 } else {
                     // console.log("response", response?.data?.result);
                     setCompany(response?.data?.result?.data);
 
                     //  let arr = []
 
                     //  response?.data?.result?.data.forEach((item) => {
                     //    arr.push(item.companyname);
 
 
                     //  });
 
                     const arrOfObj = response?.data?.result?.data.map((item) => {
                         return { value: item.companyname, label: item.companyname, id: item.companyid, accountmanager: item.accountmanager, status: item.status };
                     });
                     const arrOfObj2 = response?.data?.result?.individualCompanies.map((item) => {
                         return { value: item.companyname, label: item.companyname, id: item.companyid, accountmanager: item.accountmanager, status: item.status };
                     });
                     setCompanyData(arrOfObj);
                     setIndividualCompaniesList(arrOfObj2);
                 }
 
             });
     }
 
 
 
     const getFollowup = (e) => {
         GetTimeActivity()
         const token = localStorage.getItem("token")
         axios({
             method: 'GET',
             url: lambda + '/followup?appname=' + appname + '&clientid=' + id + "&token=" + token,
         })
             .then(function (response) {
                 if (response?.data?.result === "Invalid token or Expired") {
                     setShowSessionPopupup(true)
                 } else {
                     setFollowupContent(response?.data?.result?.data);
                 }
 
             });
     }
 
 
 
 
     const GetCountries = async () => {
         try {
 
             const response = await tmdbApi.getLookUp({
                 "type": ["country"],
                 "sortBy": "alpha3",
                 // "projection": "tiny"
             });
 
 
             setCountries(response?.result.data);
             const usaCountry = response?.result.data.filter(
                 eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
             );
             if(!id){
                setEditUser((prevUser) => ({
                    ...prevUser,
                    idc: usaCountry?.[0]?.alpha3 || ""
                }));
             }
            
             // console.log('responseresponseresponse',response?.result.data)
             // await axios({
             //     method: 'GET',
             //     url: "https://d4nv8o5tzs3mt.cloudfront.net/",
             // })
             //     .then(function (response2) {
             //         console.log('response2',response2)
             //       // let locData = JSON.stringify(response?.data)
             //       let temp = response2.data.headers['cloudfront-viewer-country'][0].value
             //       console.log('temp',temp)
             //       setDefaultCountryCode(temp)
 
             //       let k = response && response?.result && response?.result.data && response?.result.data.length>0 && response?.result.data.filter(eachItem=>eachItem.alpha2.trim()===temp)
 
             //       if (id===undefined) {
             //         setIdc(k[0].alpha3)
             //         let newUser = Object.assign({}, editUser);
             //         setEditUser({ ...newUser, ['idc']: k[0].alpha3 });
             //       }
 
 
 
             //     });
 
         } catch {
             console.log("error");
         }
     };
 
     // console.log('idc cccc',idc)
     // console.log('idc cccc',id)
     const validateOnchangeEmail = (e) => {
         GetTimeActivity()
         let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         if (reg.test(editUser?.emailId) === false) {
             setEmailError("Please Enter Valid Email");
         } else {
             setEmailError("");
         }
     }
     // console.log('editUser',editUser)
     const Checkcompany = (e) => {
         if (editUser?.entity === "COMPANY") {
             if (editUser?.company?.companyname === '' || editUser?.company?.companyname === undefined) {
                 // setError("Please select Company");
                 setActiveMsg("Please select Company")
                 setPopup(true)
                 // setTimeout(function () { setError("") }, 3000);
             }
         } else {
             if (editUser?.accountmanager === '' || editUser?.accountmanager === undefined) {
                 // setError("Please select Account Manager");
                 // setTimeout(function () { setError("") }, 3000);
                 setActiveMsg("Please select Account Manager")
                 setPopup(true)
 
             }
         }
 
 
     }
     const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state
        
        setEditUser((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
    
    };
 
    //  const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     if (name === "phone") {
    //         let formattedValue = value;
    //         let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
    //         const currentIdc = editUser?.idc?.trim(); // Directly get the latest idc value

    // if (currentIdc === "USA") {
    //     console.log("Using USA Format");
    //     if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
    //     if (numericValue.length > 6) {
    //         formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
    //     } else if (numericValue.length > 3) {
    //         formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
    //     } else {
    //         formattedValue = numericValue;
    //     }
    // } else if (currentIdc === "IND") {
    //     console.log("Using India Format");
    //     if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
    //     if (numericValue.length > 5) {
    //         formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
    //     } else {
    //         formattedValue = numericValue;
    //     }
    // }

    // // Update the phone number only
    // setEditUser(prev => ({ ...prev, [name]: formattedValue }));

    //       }
    //      if (e.target.name === "accountmanager") {
    //          let accountName = e.target.value.split("/");
    //          editUser[name] = accountName[0];
    //          editUser["accountManagerId"] = accountName[1];
    //          setEditUser({ ...editUser, [name]: accountName[0], accountManagerId: accountName[1] });
    //      } else if (name === "entity") {
 
    //          setEditUser({ ...editUser, [name]: value });
    //          if (value === "COMPANY") {
    //              console.log("editUser", editUser?.companyname)
    //              setEditUser({ ...editUser, companyname: [''], [name]: value })
 
    //          }
 
    //      }
    //      else if (name === "status") {
    //          if (add === false) {
    //              setCheckStatus(true)
    //          }
    //          setEditUser({ ...editUser, [name]: value });
    //      } else if (name === "followup") {
    //          setFollowupText(e.target.value)
 
    //      }
    //      else {
    //          // if (e.target.value === "ACTIVE") {
    //          //     Checkcompany();
    //          // }
 
    //          setEditUser({ ...editUser, [name]:value });
    //      }
 
 
 
    //  }
 
     // console.log("editUser-->", editUser);
 
     const handleChange = (e) => {
        const { name, value } = e.target;
    
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces
    
            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
    
            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }
    
        if (name === "accountmanager") {
            let accountName = value.split("/");
            setEditUser(prev => ({
                ...prev,
                accountmanager: accountName[0],
                accountManagerId: accountName[1]
            }));
            return;
        }
    
        if (name === "entity") {
            if (value === "COMPANY") {
                console.log("editUser", editUser?.companyname);
                setEditUser(prev => ({ ...prev, entity: value, companyname: [''] }));
            } else {
                setEditUser(prev => ({ ...prev, entity: value }));
            }
            return;
        }
    
        if (name === "status") {
            if (!add) setCheckStatus(true);
            setEditUser(prev => ({ ...prev, status: value }));
            return;
        }
    
        if (name === "followup") {
            setFollowupText(value);
            return;
        }
    
        // Handle all other fields
        setEditUser(prev => ({ ...prev, [name]: value }));
    };
    
 
     const handleUpdate = (filesData) => {
         GetTimeActivity()
         setDisableSaveBtn(true)
 
 
         let logoImage = filesData?.[0]?.filepath;
 
 
         // if (editUser?.entity === "INDIVIDUAL") {
         //     let payload = {
         //         "name": editUser?.name?.trim() ?? "",
         //         "idc": editUser?.idc === undefined ? k?.[0]?.alpha3 : editUser?.idc,
         //         "personalphone": editUser?.personalphone?.trim() ?? "",
         //         "personalemail": editUser?.personalemail?.trim() ?? "",
         //         "type": editUser?.type?.trim() ?? "",
         //         "entity": editUser?.entity?.trim() ?? "",
         //         "companyname": Array.isArray(editUser?.companyname) ? editUser?.companyname : [editUser?.companyname],
         //         "companyid": editUser?.companyid ?? "",
         //         "status": editUser?.status === "APPROVED" ? "ACTIVE" : editUser?.status,
         //     }
         //     if (checkStatus === false) {
         //         delete payload["status"];
         //     }
 
         //     const token = localStorage.getItem("token")
         //     const userid = localStorage.getItem("userId")
 
         //     axios.post(lambda + '/client?appname=' + appname + '&userId=' + userid + "&token=" + token + '&clientid=' + id, payload,
         //     )
         //         .then(function (response) {
         //             // console.log("ress", response);
         //             if (response?.data?.statusCode === 200) {
         //                 if (response?.data?.result==="Invalid token or Expired") {
         //                     setShowSessionPopupup(true)
         //                 } else {
         //                     getclient()
         //                     setUpdated(true);
         //                     setIsLoading(false);
         //                     setFollowupText("");
         //                 }
 
         //             }
         //         }).catch((err) => {
         //             setIsLoading(false);
         //             console.log('errr', err)
         //         })
         // } else {
         console.log("followuptexteditUsereditUser", addressData, editUser)
 
 
 
 
         let payload = {
             "businessname": editUser?.businessname?.trim() || "",
             "idc": editUser?.idc === undefined ? k?.[0]?.alpha3 : editUser?.idc,
             "phone": editUser?.phone?.trim() ?? "",
             "emailId": editUser?.emailId?.trim() ?? "",
             "subscription": editUser?.subscription?.trim() ?? "",
             "businessaddress": editUser?.businessaddress?.trim() ?? "",
             "logo": filesData?.length > 0 ? logoImage : editUser?.logo,
             "commissionpercentage": Number(editUser?.commissionpercentage?.trim()) ?? "",
             "settelment": editUser?.settelment?.trim() ?? "",
             // "companyname": editUser?.companyname,
             // "companyname": Array.isArray(editUser?.companyname) ? editUser?.companyname : [editUser?.companyname],
             // "companyid": editUser?.companyid ?? "",
             // "accountmanager": editUser?.companydetails?.[0]?.accountmanager ?? "",
             // "accountManagerId": editUser?.companydetails?.[0]?.accountManagerId ?? "",
             "status": editUser?.status === "APPROVED" ? "ACTIVE" : editUser?.status
         };
         let updatedFollowups = [];
         let followupTextValue = typeof followuptext === "string" ? followuptext.trim() : "";
         if (followupTextValue?.length > 0) {
             let followData = {
                 followup: followuptext.trim(),
                 created: new Date()
             };
 
             let previousFollowups = Array.isArray(editUser?.followup)
                 ? editUser.followup
                 : editUser?.followup
                     ? [editUser.followup]
                     : [];
 
             updatedFollowups = [...previousFollowups, followData]; // Append new data
             payload["followup"] = updatedFollowups; // Store only if follow-up text exists
 
             // console.log("followDataArray", updatedFollowups);
         }
 
 
         if (checkStatus === false) {
             delete payload["status"];
         }
 
         console.log("payload", payload);
         const token = localStorage.getItem("token")
         const userid = localStorage.getItem("userId")
 
         axios.post(lambda + '/updateClient?appname=' + appname + '&userId=' + userid + '&clientid=' + id, payload,)
             // "&token=" + token 
             .then(function (response) {
                 if (response?.data?.statusCode === 200) {
                     if (response?.data?.result === "Invalid token or Expired") {
                         setShowSessionPopupup(true)
                     } else {
                         getclient()
 
                         setIsLoading(false);
                         setToastMessage("Client Details Updated Successfully")
                         setToastType("success")
                         setFollowupText("");
                         setClientFlag(true)
                     }
                 }
             }).catch((err) => {
                 setIsLoading(false);
                 console.log('errr', err)
             });
 
         // }
     }
 
 
     // console.log('userData.type', userData?.type)
     // const handleUpdateNew = async () => {
     //     GetTimeActivity();
 
     //     const buildPayload = () => {
     //         return {
     //             "name": editUser?.name?.trim() || "",
     //             "idc": editUser?.idc === undefined ? k?.[0]?.alpha3 : editUser?.idc,
     //             "personalphone": editUser?.personalphone?.trim() ?? "",
     //             "personalemail": editUser?.personalemail?.trim() ?? "",
     //             "type": editUser?.type ?? "",
     //             "entity": editUser?.entity || "",
     //             "companyname": Array.isArray(editUser?.companyname) ? editUser?.companyname : [editUser?.companyname],
     //             "companyid": editUser?.companyid,
     //             "status": editUser?.status === "APPROVED" ? "ACTIVE" : checkStatus ? editUser?.status : undefined,
     //             "accountmanager": editUser?.entity !== "INDIVIDUAL" ? companyDeatilsList.accountmanager || "" : undefined,
     //             "accountManagerId": editUser?.entity !== "INDIVIDUAL" ? companyDeatilsList.accountManagerId || "" : undefined
     //         };
     //     };
 
     //     const payload = buildPayload();
 
     //     const token = localStorage.getItem("token");
     //     const userId = localStorage.getItem("userId");
 
     //     try {
     //         const response = await axios.post(
     //             `${lambda}/client?appname=${appname}&userId=${userId}&token=${token}`,
     //             payload
     //         );
 
     //         console.log("response", response);
 
     //         if (response?.data?.statusCode === 200) {
     //             if (response?.data?.result === "Invalid token or Expired") {
     //                 setShowSessionPopupup(true);
     //             } else {
     //                 getclient();
     //                 setUpdated(true);
     //                 setIsLoading(false);
     //                 setFollowupText("");
     //             }
     //         }
     //     } catch (err) {
     //         setIsLoading(false);
     //         console.error('Error:', err);
     //     }
     // };
 
 
     const Validate = () => {
         GetTimeActivity();
         let formIsValid = true;
 
         if (!editUser?.businessname?.trim()) {
             setNameError("Please Enter Name");
             setTimeout(() => setNameError(""), 3000);
             formIsValid = false;
         }
 
         if (add === true) {
             if (!editUser?.emailId?.trim()) {
                 setEmailError("Please Enter Email");
                 setTimeout(() => setEmailError(""), 3000);
                 formIsValid = false;
             }
 
             const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
             if (!regEx.test(editUser?.emailId?.trim())) {
                 setEmailError("Enter Valid Email");
                 setTimeout(() => setEmailError(""), 3000);
                 formIsValid = false;
             }
         }
 
         if (!editUser?.subscription?.trim()) {
             setPlanError("Please Select Plan");
             setTimeout(() => setPlanError(""), 3000);
             formIsValid = false;
         }
         if (!editUser?.settelment?.trim()) {
            setDaysError("Please Select settelment");
            setTimeout(() => setDaysError(""), 3000);
            formIsValid = false;
        }
        if (!editUser?.commissionpercentage?.trim()) {
            setPercentError("Please Select commission percentage");
            setTimeout(() => setPercentError(""), 3000);
            formIsValid = false;
        }

         if (!editUser?.businessaddress?.trim()) {
             setAddressError("Please Enter Address");
             setTimeout(() => setAddressError(""), 3000);
             formIsValid = false;
         }
 
      
 
      
         if (!editUser?.phone?.trim()) {
            setPhoneError("Enter phone number");
            setTimeout(() => setPhoneError(""), 3000);
            formIsValid = false;
        }else 
         if (
            (editUser.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(editUser.phone)) ||
            (editUser.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(editUser.phone))
        ) {
            setPhoneError("Invalid phone number format");
            setTimeout(() => setPhoneError(""), 3000);
            formIsValid = false;
        }
         return formIsValid;
     };
 
 
 
 
 
 
     const handleFollowup = async () => {
         GetTimeActivity()
         if (followuptext) {
             try {
                 const response = await tmdbApi.FollowUp({
                     "followup": followuptext,
                     "clientid": id,
 
                 });
 
 
             } catch {
                 console.log("error");
             }
         }
     };
     const handleReject = (e) => {
         setEditUser({ ...editUser, status: editUser.previousStatus })
         setLastStatus(editUser?.previousStatus)
         setShowRejectPopup(false)
         setCheckStatus(true)
     }
     console.log("lastStatussssssssssssssssssssssss",lastStatus)
     console.log("editUserrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr",editUser)
     const handleSubmit = (e) => {
         GetTimeActivity()
         const isValid = Validate();
 
         if (!editUser.businessaddress) {
             setAddressError("Please enter a valid address.");
             return;
         } else {
             setAddressError(""); // Clear error if valid
         }
         if (isValid && add) {
             console.log('add--->111112', editUser, addressData)
             setIsLoading(true);
             handleUploadSubmit();
         } else if (isValid) {
             console.log('add--->')
             setIsLoading(true);
             handleUploadSubmit();
 
             //handleFollowup();
         }
 
     }
     // console.log('add--->',add)
     const SaveClient = async (filesData) => {
         GetTimeActivity()
 
 
         let logoImage = appResourcesUrl + filesData?.[0]?.filepath;
 
 
 
 
         let type = localStorage.getItem("ClientType")
         // if (editUser?.entity === "INDIVIDUAL") {
 
         //     try {
         //         const response = await tmdbApi.SaveClient({
         //             "businessname": editUser?.name?.trim() ?? "",
         //             "personalemail": editUser?.personalemail?.trim() ?? "",
         //             "idc": editUser?.idc?.trim() ?? "",
         //             "personalphone": editUser?.personalphone?.trim() ?? "",
         //             "plans": editUser?.type?.trim() ?? "",
         //             "entity": editUser?.entity?.trim() ?? "",
         //             "companyid": editUser?.companyid ?? "",
         //             "companyname": editUser?.companyname ? [editUser?.companyname] : [editUser?.name],
         //             "status": type === "SUPER ADMIN" || type === "ADMIN" ? "ACTIVE" : "PENDING APPROVAL",
         //             "createdBy": { userid: userData?.userid, username: userData?.name }
         //         });
 
         //         if (response?.result === "Client already exists") {
         //             setIsLoading(false);
         //             setActiveMsg("Client Already Exists")
         //             setPopup(true)
 
 
         //         }
         //         else if (response?.result === "PENDING VERIFICATION") {
         //             setIsLoading(false);
         //             setActiveMsg("Pending Verification")
         //             setPopup(true)
         //         }
         //         else if (response?.result === "PENDING TERMS") {
         //             setActiveMsg("Pending Terms")
         //             setPopup(true)
         //             setIsLoading(false);
         //             setDisableSaveBtn(false)
         //         }
         //         else if (response?.result==="Invalid token or Expired") {
         //             setShowSessionPopupup(true)
         //         }
         //         else if (response?.result !== "PENDING VERIFICATION" && response?.result !== "Client already exists") {
         //             id = response?.result;
         //             navigate("/editclient/" + id);
         //             getclient();
         //             setAdd(false);
 
         //             setMessage(true);
         //             setIsLoading(false);
         //         }
 
 
         //     } catch {
         //         console.log("error");
         //         setIsLoading(false);
         //     }
         // } else {
         try {
 
             let geoData = {}
             if (Object.keys(addressData)?.length > 0) {
                 geoData = {
                     latitude: addressData?.geolocation?.location?.lat?.(),
                     longitude: addressData?.geolocation?.location?.lng?.(),
                     url: addressData?.url,
                     state: addressData?.state,
                     city: addressData?.city,
                     county: addressData?.county,
                     businessaddress: addressData?.fullAddress
                 }
             }
 
             let updateObject = {
                 "businessname": editUser?.businessname?.trim() ?? "",
                 "emailId": editUser?.emailId?.trim() ?? "",
                 "idc": editUser?.idc?.trim() ?? "",
                 "phone": editUser?.phone?.trim() ?? "",
                 "subscription": editUser?.subscription?.trim() ?? "",
                 // "type": editUser?.type?.trim() ?? "",
                 "commissionpercentage": Number(editUser?.commissionpercentage?.trim()) ?? "",
                 "settelment": editUser?.settelment?.trim() ?? "",
                 'businessaddress': editUser?.businessaddress?.trim() ?? "",
                 "logo": filesData?.length > 0 ? logoImage : "",
                 // "entity": editUser?.entity?.trim() ?? "",
                 // "companyid": editUser?.companyid ?? "",
                 // "accountmanager": companyDeatilsList.accountmanager ?? "",
                 // "accountManagerId": companyDeatilsList.accountManagerId ?? "",
                 // "companyname": [editUser?.companyname],
                 // "status": type === "SUPER ADMIN" || type === "ADMIN" ? "ACTIVE" : "PENDING APPROVAL",
                 // createdBy: { userid: userData?.userid, username: userData?.name }
             }
 
             updateObject = { ...updateObject, ...geoData };
 
             console.log("updateObject", updateObject)
 
             const response = await tmdbApi.SaveClient(updateObject);
 
             if (response?.result === "Email Alraedy Exists") {
                 setIsLoading(false);
 
                 setToastMessage("Client Already Exists")
                 setToastType("warning")
                 //  setPopup(true)
                 setDisableSaveBtn(false)
             }
             else if (response?.result === "PENDING VERIFICATION") {
 
                 setToastMessage("Pending Verification")
                 setToastType("warning")
                 //  setPopup(true)
                 setIsLoading(false);
                 setDisableSaveBtn(false)
 
             }
             else if (response?.result === "PENDING TERMS") {
                 // setActiveMsg("Pending Terms")
                 setToastMessage("Pending Terms")
                 setToastType("warning")
                 //  setPopup(true)
                 setIsLoading(false);
                 setDisableSaveBtn(false)
 
             }
             else if (response?.result === "Invalid token or Expired") {
                 setShowSessionPopupup(true)
                 setDisableSaveBtn(false)
             } else {
                 if (response?.result !== "") {
                     id = response?.result;
                     navigate("/editclient/" + id);
                     getclient()
                     // setMessage(true);
                     setIsLoading(false);
                     setAdd(false)
                     setToastMessage("Client Details Created Successfully")
                     setToastType("success")
                     setClientFlag(true)
                 }
             }
 
 
         } catch {
             console.log("error");
             setIsLoading(false);
         }
 
         // }
 
     };
 
     const handleBack = () => {
         GetTimeActivity()
         if (add === false) {
             navigate({
                 pathname: "/clients",
                 state: { search: true }
             });
         } else {
             navigate("/clients")
         }
     }
 
     function onConfirm() {
         GetTimeActivity()
         setSuccess(false);
 
     };
     function onConfirm2() {
         GetTimeActivity()
         setMessage(false);
         //  navigate("/clients")
     };
     function onConfirm1() {
         GetTimeActivity()
         setUpdated(false);
     };
 
     function onConfirm3() {
         GetTimeActivity()
         setTermsSuccess(false);
 
     };
     const returnArray = (arr) => {
         let arr2 = []
         arr2.push(arr.value)
         return arr2
     }
     const returnId = (arr) => {
         let arr2 = []
         arr2.push(arr.id)
         return arr2
     }
     //  console.log("countryCodeeeeeeeeeeeeeeeee",editUser?.idc)
     const handleChangeMultiSelect = (selected) => {
         GetTimeActivity()
         // setEditUser({...editUser , companyname:selected.value, companyid:selected.id})
 
         setCheckAM(selected?.accountmanager ? selected?.accountmanager : "")
         let selectedArray = returnArray(selected);
         let selectedId = returnId(selected).toString();
         // console.log("selected--->", selected)
         selectedCom["companyname"] = selectedArray
         selectedCom["companyid"] = selectedId
         setSelectedCom({ ...selectedCom });
         setEditUser({ ...editUser, companyname: selectedArray, companyid: [selectedId], companydetails: [selected] })
 
     };
     // console.log('checkAm',checkAM)
     // console.log("editUser",editUser?.companyid)
 
     function onCancel() {
         GetTimeActivity()
         setPopup(false);
     }
     // const followUpClick = () => {
     //     getclient();
     // };
     // console.log("userdataaaaaaaaaaaaaaaaaaaaaaaaaaaa", editUser)
     const handleTermsEmail = () => {
         GetTimeActivity()
         let payload = {
             "name": editUser?.name,
             "personalemail": editUser?.personalemail,
         }
         const token = localStorage.getItem("token")
         const userid = localStorage.getItem("userId")
 
         axios.put(lambda + '/termsEmail?appname=' + appname + '&clientid=' + editUser?.clientid + "&token=" + token + "&userid=" + userid,
 
             payload,
 
 
         )
             .then(function (response) {
                 // console.log("res", response)
 
                 if (response?.data?.statusCode === 200) {
                     if (response?.data?.result === "Invalid token or Expired") {
                         setShowSessionPopupup(true)
                     } else {
                         setTermsSuccess(true)
 
                     }
                 }
             });
     }
     //  console.log("editUserrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr",editUser)
 
     // // console.log("editUser",editUser);
 
     let k = countries && countries?.length > 0 && countries?.filter(eachItem => eachItem.alpha2 === defaultCountryCode)
     // console.log('kkkkkkkkkk', selectedPlace, editUser?.businessaddress)
     const idcValue = editUser?.idc;
     // console.log("idcValue",idcValue,editUser)
     return (
         <>
             {showSessionPopupup && <SessionPopup />}
 
             <div id="layout-wrapper">
                 <Header />
                 <Sidebar />
                 <SweetAlert show={invalidContent}
                     custom
                     confirmBtnText="ok"
                     confirmBtnBsStyle="primary"
                     title={"Clients Not Found"}
                     onConfirm={e => onclickInvalid()}
                 >
                 </SweetAlert>
                 <Modal className="access-denied" show={showRejectPopup}>
 
                     <div className="modal-body enquiry-form">
                         <div className="container">
                             <button className="close-btn" onClick={e => setShowRejectPopup(false)}><span className="material-icons">close</span></button>
                             {/* <span className="material-icons access-denied-icon">delete_outline</span> */}
                             <span class="material-icons material-symbols-outlined access-denied-icon">history</span>
 
                             {/* <i class="fas fa-history"></i> */}
 
                             <h3>Revert Status</h3>
                             <p>This action cannot be undone.</p>
                             <p>Are you sure you want to roll back to the previous status?</p>
                             <div className="popup-footer">
                                 <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => handleReject()}>Yes</button>
                                 <button className="fill_btn" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => setShowRejectPopup(false)}>No</button>
                             </div>
                         </div>
                     </div>
 
                 </Modal>
                 {!invalidContent &&
                     <div className="main-content create-user edit-content add-client">
 
                         <div className="page-content ">
                             <div className="container-fluid">
 
 
 
                                 <div className="row mb-4 breadcrumb" id="breadcrumb-container">
                                     <div className="col-lg-12">
                                         <div className="d-flex align-items-center">
                                             <div className="flex-grow-1">
                                                 <h4 className="mb-2 card-title" id="client-title">
                                                     {add === true ? "ADD" : "EDIT"} CLIENT
                                                 </h4>
                                                 <p className="menu-path" id="menu-path">
                                                     <span id="menu-path-client-management">Client Management</span> /
                                                     <b id="menu-path-action">{add === true ? "Add" : "Edit"} Client</b>
                                                 </p>
                                             </div>
                                             <div>
                                                 {add === false && lastStatus2 === "PENDING TERMS" ? (
                                                     <button
                                                         className="fill-btn-style"
                                                         onClick={handleTermsEmail}
                                                         style={{ marginRight: "10px" }}
                                                         id="send-terms-email"
                                                     >
                                                         Send Terms Email
                                                     </button>
                                                 ) : null}
                                             </div>
                                             <div>
                                                 <button
                                                     onClick={handleBack}
                                                     className="stroke-btn-style"
                                                     id="back-button"
                                                 >
                                                     <span className="material-symbols-outlined" id="back-icon">
                                                         arrow_back
                                                     </span>
                                                     back
                                                 </button>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
 
                                 <div className="create-user-block">
 
                                     <div className="form-block">
                                         <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                                             <li className="nav-item" role="presentation">
                                                 <a className="nav-link active" data-bs-toggle="tab" href="#home1" role="tab" aria-selected="true">
                                                     <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                     <span className="d-none d-sm-block">DETAILS</span>
                                                 </a>
                                             </li>
                                          
                                                 <>
                                                     {/* <li className="nav-item" role="presentation">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#profile1" role="tab" aria-selected="false" tabIndex="-1">
                                                       <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                       <span className="d-none d-sm-block">DOCUMENTS</span>
                                                   </a>
                                               </li> */}
                                                     <li className="nav-item" role="presentation">
                                                         <a className="nav-link" data-bs-toggle="tab" href="#messages1" role="tab" aria-selected="false" tabIndex="-1">
                                                             <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                             <span className="d-none d-sm-block">FOLLOW UP</span>
                                                         </a>
                                                     </li></>
                                                
 
 
                                         </ul>
                                         <div className="tab-content p-3 text-muted">
                                             <div className="tab-pane active show add-client-details" id="home1" role="tabpanel">
                                                 {editUser && Object.keys(editUser)?.length > 0
 
                                                     &&
                                                     // countries?.length > 0 ?
                                                     <>
                                                         <div className="row">
                                                             <h5 className="form-title" id="basic-details-heading">Basic Details</h5>
 
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="business-name-label">BUSINESS NAME<span className="required">*</span></label>
                                                                     <input className="form-control" placeholder="Enter Name" type="text" name="businessname" value={editUser?.businessname} onChange={(e) => handleChange(e)} id="business-name-input" />
                                                                     {nameError !== "" ? <span className="errormsg" id="business-name-error" style={{ fontWeight: 'bold', color: 'red' }}>{nameError}</span> : ""}
                                                                 </div>
                                                             </div>
 
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="email-label">EMAIL<span className="required">*</span></label>
                                                                     {add === false ?
                                                                         <input className="form-control contact-number" type="email" value={editUser?.emailId} id="email-input" disabled name="emailId" />
                                                                         :
                                                                         <input className="form-control contact-number" type="email" value={editUser?.emailId} name="emailId" placeholder="Please Enter Email" onChange={(e) => handleChange(e)} id="email-input" onBlur={e => validateOnchangeEmail(e)} />
                                                                     }
                                                                     {emailError !== "" ? <span className="errormsg" id="email-error" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span> : ""}
                                                                 </div>
                                                             </div>
 
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="phone-label">PHONE NUMBER<span className="required">*</span></label>
                                                                     <div className="country-code">
                                                                         <select name="idc" value={editUser?.idc} className="colorselect capitalize" onChange={(e) => handleCountryChange(e)} id="country-code-select">
                                                                             {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                                 return (
                                                                                     <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                                 )
                                                                             }
                                                                             )}
                                                                         </select>
                                                                         <input className="form-control contact-number" type="text" name="phone" value={editUser?.phone} placeholder="Enter Phone Number" onChange={(e) => handleChange(e)} id="phone-number-input" inputMode="numeric" />
                                                                         <span className="errormsg" id="country-code-error" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                                         <span className="errormsg" id="phone-number-error" style={{ fontWeight: 'bold', color: 'red' }}>{phoneError}</span>
                                                                     </div>
                                                                 </div>
                                                             </div>
 
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="plans-label">Subscriptions<span className="required">*</span></label>
                                                                     <select
                                                                        disabled={editUser?.status==="ACTIVE"}
                                                                         className="form-select"
                                                                         name="subscription"
                                                                         onChange={(e) => handleChange(e)}
                                                                         value={editUser?.subscription?.toLowerCase() || ""}
                                                                         id="plans-select"
                                                                     >
                                                                         <option value="" id="plan-option-default">Select Subscriptions</option>
                                                                         {subscriptionsData && subscriptionsData
    .filter(plan => plan.status === 'ACTIVE') // Filter only ACTIVE plans
    .map((plan, index) => (
        <option
            key={plan?.planname}
            value={plan?.planname?.toLowerCase()}
            id={`plan-option-${index}`} // Unique ID for each option
        >
            {plan?.planname}
        </option>
    ))
}

                                                                     </select>
 
                                                                     {planError !== "" ? <span className="errormsg" id="plans-error" style={{ fontWeight: 'bold', color: 'red' }}>{planError}</span> : ""}
                                                                 </div>
                                                             </div>
                                                            
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="business-address-label">BUSINESS ADDRESS<span className="required">*</span></label>
                                                                     {mapsAPIkey != false && <LocationSearch
                                                                         setSelectedPlace={(place) => {
                                                                             setSelectedPlace(place);
                                                                             handleAddressChange(addressData);
                                                                         }}
                                                                         setAddressData={(data) => {
                                                                             setAddressData(data);
                                                                             handleAddressChange(data);
                                                                         }}
                                                                         //  setEditUser={(data) => {
                                                                         //     setEditUser(data);
                                                                         //     handleChange(data);
                                                                         // }}
                                                                         onChange={(e) => {
                                                                             setEditUser((prev) => ({ ...prev, businessaddress: e.target.value }));
                                                                             setAddressData({ fullAddress: e.target.value });  // Ensure addressData is also updated
                                                                         }}
                                                                         onBlur={() => handleAddressChange({ fullAddress: editUser?.businessaddress })}
                                                                         mapVisible={false}
                                                                         formData={editUser}
                                                                         mapsAPIkey={mapsAPIkey}
                                                                         id="business-address-input"
                                                                     />}
                                                                     {addressError !== "" ? <span className="errormsg" id="business-address-error" style={{ fontWeight: 'bold', color: 'red' }}>{addressError}</span> : ""}
                                                                 </div>
                                                             </div>
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="business-name-label">Commission Percentage<span className="required">*</span></label>
                                                                     <input className="form-control" placeholder="Enter Percentage" type="text" name="commissionpercentage" value={editUser?.commissionpercentage} onChange={(e) => handleChange(e)} id="business-name-input" />
                                                                     {percentError !== "" ? <span className="errormsg" id="business-name-error" style={{ fontWeight: 'bold', color: 'red' }}>{percentError}</span> : ""}
                                                                 </div>
                                                             </div>
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                     <label className="form_label" id="plans-label">Settelment<span className="required">*</span></label>
                                                                     <select
                                                                       
                                                                         className="form-select"
                                                                         name="settelment"
                                                                         onChange={(e) => handleChange(e)}
                                                                         value={editUser?.settelment}
                                                                         id="plans-select"
                                                                     >
                                                                         <option value="" id="plan-option-default">Select </option>
                                                                         <option value="week" id="plan-option-week">Week</option>
                                                                         <option value="15-days" id="plan-option-15-days">15 Days</option>
                                                                         <option value="one-month" id="plan-option-one-month">One Month</option>
                                                                        
                                                                     </select>
 
                                                                     {daysError !== "" ? <span className="errormsg" id="plans-error" style={{ fontWeight: 'bold', color: 'red' }}>{daysError}</span> : ""}
                                                                 </div>
                                                             </div>
                                                             {add === false && editUser?.created && (
                                                             <div className="col-md-6">
                                                                 <div className="input-field">
                                                                 <label className="form_label" htmlFor="created-on">Created On</label>
                                                                             <input
                                                                                 className="form-control"
                                                                                 placeholder="Enter Name"
                                                                                 type="text"
                                                                                 value={editUser.created ? moment.utc(editUser.created).format("MM-DD-YYYY") : ""}
                                                                                 id="created-on"
                                                                                 disabled
                                                                             />
                                                                   
                                                                 </div>
                                                             </div>
                                                             )}
                                                             {add === false && editUser?.created && (
                                                                 <div>
                                                                     {/* {editUser?.created && (
                                                                         <div className="col-md-4 mt-3">
                                                                             <label className="form_label" htmlFor="created-on">Created On</label>
                                                                             <input
                                                                                 className="form-control"
                                                                                 placeholder="Enter Name"
                                                                                 type="text"
                                                                                 value={editUser.created ? moment.utc(editUser.created).format("MM-DD-YYYY") : ""}
                                                                                 id="created-on"
                                                                                 disabled
                                                                             />
                                                                         </div>
                                                                     )} */}
                                                                     {editUser?.termsAccptedOn && (
                                                                         <div className="col-md-4">
                                                                             <label className="form_label" htmlFor="terms-accepted-on">Terms Accepted On</label>
                                                                             <input
                                                                                 className="form-control"
                                                                                 placeholder="Enter Name"
                                                                                 type="text"
                                                                                 value={new Date(editUser?.termsAccptedOn).toLocaleDateString('en-IN', {
                                                                                     day: 'numeric',
                                                                                     month: 'short',
                                                                                     year: 'numeric',
                                                                                     hour: 'numeric',
                                                                                     minute: 'numeric',
                                                                                 })}
                                                                                 id="terms-accepted-on"
                                                                                 disabled
                                                                             />
                                                                         </div>
                                                                     )}
                                                                     {editUser?.approvedOn && (
                                                                         <div className="col-md-4">
                                                                             <label className="form_label" htmlFor="approved-on">Approved On</label>
                                                                             <input
                                                                                 className="form-control"
                                                                                 placeholder="Enter Name"
                                                                                 type="text"
                                                                                 value={new Date(editUser?.approvedOn).toLocaleDateString('en-IN', {
                                                                                     day: 'numeric',
                                                                                     month: 'short',
                                                                                     year: 'numeric',
                                                                                     hour: 'numeric',
                                                                                     minute: 'numeric',
                                                                                 })}
                                                                                 id="approved-on"
                                                                                 disabled
                                                                             />
                                                                         </div>
                                                                     )}
                                                                     {userData?.type === "ADMIN" && editUser?.verificationCode && (
                                                                         <div className="col-md-4">
                                                                             <label className="form_label" htmlFor="verification-code">Verification Code</label>
                                                                             <input
                                                                                 className="form-control"
                                                                                 placeholder="Enter Name"
                                                                                 type="text"
                                                                                 value={editUser?.verificationCode}
                                                                                 id="verification-code"
                                                                                 disabled
                                                                             />
                                                                         </div>
                                                                     )}
                                                                     {userData?.type === "ADMIN" && editUser?.otp && (
                                                                         <div className="col-md-4">
                                                                             <label className="form_label" htmlFor="otp">OTP</label>
                                                                             <input
                                                                                 className="form-control"
                                                                                 placeholder="Enter Name"
                                                                                 type="text"
                                                                                 value={editUser?.otp}
                                                                                 id="otp"
                                                                                 disabled
                                                                             />
                                                                         </div>
                                                                     )}
                                                                 </div>
                                                             )}
 
                                                             {add === false && editUser?.status!=="ACTIVE" ?
                                                                 <div >
                                                                     <div className="col-md-12 mt-2">
                                                                         <label className="verticalnav-address-input">FOLLOW UP</label>
                                                                         <textarea id="verticalnav-address-input" name="followup" onChange={(e) => handleChange(e)} value={followuptext} className="form-control" rows="2" style={{ marginBottom: "10px" }}></textarea>
                                                                     </div>
                                                                 </div>
 
                                                                 : ""}
 
                                                             {error !== "" && (
                                                                 <span className="errormsg" id="error-message" style={{
                                                                     fontWeight: 'bold',
                                                                     color: 'red',
                                                                 }}>
                                                                     {error}
                                                                 </span>
                                                             )}
                                                             <label className="form_label" for="html">Upload Logo</label>
                                                             <div className="upload-zone input-group mb-2 mr-sm-2">
 
                                                                 {editUser?.logo && editUser.logo.length > 0 ? (
                                                                     <div className="upload-icon mt-1">
                                                                         <div className="img_block add_img_block">
                                                                             <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>
                                                                                 close
                                                                             </span>
 {editUser?.logo?.startsWith("blob:")?<img src={`${editUser.logo}`} id="activimg" alt="Uploaded Logo" />:<img src={`${image}${editUser.logo}`} id="activimg" alt="Uploaded Logo" />}
                                                                             
                                                                         </div>
                                                                     </div>
                                                                 ) : (
                                                                     <>
                                                                         <div>
                                                                             <input
                                                                                 type="file"
                                                                                 id="file-upload"
                                                                                 accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                                 className="d-none"
                                                                                 multiple={false}
                                                                                 onChange={handleFileChange}
                                                                                 style={{ display: 'none' }}
                                                                             />
                                                                             <label htmlFor="file-upload" className="stroke-button">
                                                                                 <span className="material-icons">file_upload</span> 
                                                                             </label>
                                                                         </div>
                                                                         <div className="file_requirements">
                                                                             <p>Maximum file size: 5MB</p>
                                                                             <p>Supported formats: JPG, PNG, HEIC</p>
                                                                         </div>
                                                                     </>
                                                                 )}
 
 
                                                                 {/* {errors.logo && <div className="error">{errors.logo}</div>} */}
 
 
                                                             </div>
                                                             <div className="row status client_status">
 
                                                                 <div className="col-md-9 justify-content-between ps-0 d-flex">
                                                                     {add === false ?
                                                                         <div className="input-field d-flex align-items-center">
                                                                             <label className="col-form-label">Status</label>
 
                                                                             <>
                                                                                 {lastStatus === "ACTIVE" || lastStatus === "INACTIVE" ?
                                                                                     (<select className="form-select" name="status" value={editUser?.status} onChange={(e) => handleChange(e)} >
 
                                                                                         <option value="INACTIVE">INACTIVE</option>
                                                                                         <option value="ACTIVE">ACTIVE</option>
 
                                                                                     </select>) : lastStatus === "REJECT" ? (<select className="form-select" name="status" value={editUser?.status} onChange={(e) => handleChange(e)} >
 
                                                                                     <option value="APPROVED">APPROVED</option>
                                                                                     <option value="REJECT">REJECT</option>
 
 </select>)
                                                                                     // : lastStatus === "REJECT" ? <><input className="form-control contact-number" type="text" value="REJECTED" id="example-email-input" disabled />
 
 
 
 
                                                                                     //     <a onClick={e => setShowRejectPopup(true)} className="roll-back btn btn-primary"><span class="material-icons-outlined">history</span>RollBack</a>
 
 
                                                                                     //     <div className="pre_status d-flex align-items-center">
                                                                                     //         <label className="col-form-label">Previous Status</label>
                                                                                     //         <input className="form-control contact-number" type="text" value={editUser?.previousStatus} id="example-email-input" disabled />
                                                                                     //     </div>
                                                                                     // </> 
                                                                                     : <select className="form-select" name="status" value={editUser?.status} onChange={(e) => handleChange(e)}  >
 
                                                                                         {/* <option value="PENDING APPROVAL">Pending Approval</option>
                  <option value="PENDING TERMS">Pending Terms</option> */}
                                                                                         <option value={lastStatus}>{lastStatus}</option>
                                                                                         <option value="APPROVED">APPROVED</option>
                                                                                         <option value="REJECT">REJECT</option>
 
                                                                                     </select>
                                                                                 }
                                                                             </>
 
 
                                                                         </div>
                                                                         : null}
 
                                                                 </div>
 
                                                             </div>
 
                                                             {/* <div className="col-md-3 mt-3 mb-3">
        <button
          onClick={handleSubmit}
          className={`fill-btn-style ${disableSaveBtn ? 'pe-none' : ''}`}
          id="update-button"
        >
          {isLoading ? (
            <img
              src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"
              className="loading-icon"
              alt="Loading"
              id="loading-icon"
            />
          ) : null}
          UPDATE
        </button>
  </div> */}
                                                             <div className="col-md-6"></div>
                                                             <div className="row ps-0">
                                                                 <div className="col-md-3 mt-3 mb-3">
                                                                     <button
                                                                         onClick={handleSubmit}
                                                                         className={`fill-btn-style ${disableSaveBtn ? 'pe-none' : ''}`}
                                                                         id="save-button"
                                                                     >
                                                                         {isLoading ? (
                                                                             <img
                                                                                 src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                                 className="loading-icon"
                                                                                 alt="Loading"
                                                                                 id="loading-icon-save"
                                                                             />
                                                                         ) : null}
                                                                         {clientFlag === false ? "Save" : "Update"}
                                                                     </button>
                                                                 </div>
                                                             </div>
                                                             {/* <div className="row status client_status">
    <div className="col-md-9 justify-content-between ps-0 d-flex">
      {add === false ? (
        <div className="input-field d-flex align-items-center">
          <label className="col-form-label" htmlFor="status-select">Status</label>
          <>
            {lastStatus === "ACTIVE" || lastStatus === "INACTIVE" ? (
              <select
                className="form-select"
                name="status"
                id="status-select"
                value={editUser?.status}
                onChange={(e) => handleChange(e)}
              >
                <option value="INACTIVE">Inactive</option>
                <option value="ACTIVE">Active</option>
              </select>
            ) : lastStatus === "REJECT" ? (
              <>
                <input
                  className="form-control contact-number"
                  type="text"
                  value="REJECTED"
                  id="rejected-status"
                  disabled
                />
                <a
                  onClick={(e) => setShowRejectPopup(true)}
                  className="roll-back fill-btn-style"
                  id="rollback-button"
                >
                  <span className="material-icons-outlined">history</span>RollBack
                </a>
                <div className="pre_status d-flex align-items-center">
                  <label className="col-form-label" htmlFor="previous-status">Previous Status</label>
                  <input
                    className="form-control contact-number"
                    type="text"
                    value={editUser?.previousStatus}
                    id="previous-status"
                    disabled
                  />
                </div>
              </>
            ) : (
              <select
                className="form-select"
                name="status"
                id="status-select-other"
                value={editUser?.status}
                onChange={(e) => handleChange(e)}
              >
                <option value={lastStatus}>{lastStatus}</option>
                <option value="APPROVED">Approved</option>
                <option value="REJECT">Reject</option>
                <option value="INACTIVE">Inactive</option>
              </select>
            )}
          </>
        </div>
      ) : null}
    </div>
    {add === false ? (
    )}
  </div> */}
 
                                                         </div>
                                                     </>
                                                     // : <div className="row"><Loader /></div>
 
                                                 }
                                             </div>
 
                                             <div className="tab-pane" id="messages1" role="tabpanel">
                                                 <div className="mb-3 row">
                                                     {editUser && editUser?.followup && editUser?.followup?.length > 0 ?
 
                                                         <div className="col-md-12">
                                                             <label >FOLLOW UP</label>
                                                             {editUser && editUser?.followup && editUser?.followup?.map(function (item, i) {
 
 
                                                                 return (
                                                                     <div className="comments-block" key={i}>
                                                                         <p className="time">{item.created ? moment.utc(item.created).format("MM-DD-YYYY") : ""}</p>
                                                                         <p className="comments">{item.followup}</p>
                                                                         <p className="comments me-2">FollowupBy : {userData?.name}</p>
                                                                     </div>
                                                                 )
                                                             })}
 
                                                         </div>
                                                         : <div div className="followups" id="no-followups"><div className="no-documents">
                                                             <span className="material-icons-outlined" id="no-followups-icon">comment</span>
                                                             <p>No follow-ups were found</p>
                                                         </div></div>}
                                                 </div>
                                             </div>
 
 
                                         </div>
 
                                     </div>
 
                                 </div>
 
 
                             </div>
                         </div>
                         <SweetAlert show={success}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={"something went wrong"}
                             onConfirm={e => onConfirm()}
                         >
                         </SweetAlert>
                         <SweetAlert show={companyInactivePopup}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={"This client cannot be activated because the associated company is inactive"}
                             onConfirm={e => setCompanyInactivePopup(false)}
                         >
                         </SweetAlert>
                         <SweetAlert show={errAccManage}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={"Before activating this client, assign an account manager first"}
                             onConfirm={e => setErrAccManage(false)}
                         >
                         </SweetAlert>
                         <SweetAlert show={updated}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={"Client Details Updated"}
                             onConfirm={e => onConfirm1()}
                         >
                         </SweetAlert>
                         <SweetAlert show={message}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={"Client Details Saved"}
                             onConfirm={e => onConfirm2()}
                         >
                         </SweetAlert>
                         <SweetAlert show={termssuccess}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={"Terms Email sent"}
                             onConfirm={e => onConfirm3()}
                         >
                         </SweetAlert>
                         <SweetAlert show={popup}
                             custom
                             confirmBtnText="ok"
                             confirmBtnBsStyle="primary"
                             title={activeMsg}
                             onConfirm={e => onCancel()}
                         >
                         </SweetAlert>
 
                         {/* <SweetAlert show={ShowStatusErrPopup}
                              custom
                              confirmBtnText="ok"
                              confirmBtnBsStyle="primary"
                              title={"Activation can be done only when the client accepts the terms and conditions"}
                              onConfirm={e => setShowStatusErrPopup(false)}
                          >
                          </SweetAlert> */}
                         <Footer />
 
                         <Modal className="access-denied" show={ShowStatusErrPopup} >
 
                             <div className="modal-body enquiry-form">
                                 <div className="container">
                                     <button className="close-btn" onClick={e => setShowStatusErrPopup(false)}><span className="material-icons">close</span></button>
                                     <span className="material-symbols-outlined access-denied-icon">
                                         passkey
                                     </span>
                                     <h3>Activation Condition</h3>
                                     <p>Activation is subject to <br></br> acceptance    of the terms and condition by the client</p>
                                     <div className="popup-footer">
                                         <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => setShowStatusErrPopup(false)}>OK</button>
                                     </div>
 
                                 </div>
                             </div>
 
                         </Modal>
                         <ToastContainer
                             id="toastContainer"
                             position="bottom-center"
                             autoClose={3000}
                             hideProgressBar={false}
                             newestOnTop={false}
                             closeOnClick
                             rtl={false}
                             pauseOnFocusLoss
                             draggable
                             pauseOnHover={false}
                             theme="light"
                         />
                         {/* <Modal className="access-denied" show={popup}>
  
                              <div className="modal-body enquiry-form">
                                  <div className="container">
                                      <button className="close-btn" onClick={e => onCancel()}><span className="material-icons">close</span></button>
  
                                      <span className="material-icons access-denied-icon"></span>
                                      <h3></h3>
                                      <p></p>
                                      <h5>Please provide Necessary Details in Company Level to Active Client</h5>
                                  </div>
                              </div>
  
                          </Modal> */}
                     </div>
                 }
 
 
 
             </div>
         </>
     );
 };
 
 export default EditClient;
 